var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    fill: "#2F3EAC",
    stroke: "#2F3EAC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_4517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 17,
    height: 17,
    fill: "#D9D9D9",
    stroke: "#2F3EAC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_4517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1715 15.3706L18.0439 8.49815L19.095 9.54922L11.1627 17.4815L6.90537 13.2242L7.95645 12.1731L11.1539 15.3706L11.1627 15.3794L11.1715 15.3706Z",
    fill: "white",
    stroke: "#2F3EAC",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChckedIcon);
export default __webpack_public_path__ + "static/media/chckedIcon.3e01e5d03e35defb9f9f406ba42d2473.svg";
export { ForwardRef as ReactComponent };